import { LoadEnergyEfficiency } from '@/dto/scenario/load/LoadEnergyEfficiency';
import { DtoExt } from '@/classes/scenario/DtoExt';

export class LoadEnergyEfficiencyExt extends DtoExt {

  public static fromDto(dto: LoadEnergyEfficiency): LoadEnergyEfficiencyExt {
    return new LoadEnergyEfficiencyExt({
      estimatedEnergySavings: dto.estimatedEnergySavings,
      // startDate: (dto.startDate && new Date(dto.startDate)) || null,
      investmentCost: dto.investmentCost
    } as any);
  }

  public estimatedEnergySavings: number | null = null;
  // public startDate: Date | null = null;
  public investmentCost: number | null = null;

  constructor(options?: LoadEnergyEfficiencyExt | null) {
    super();
    if (options) {
      DtoExt.assignToThis(this, options);
      // this.estimatedEnergySavings = options.estimatedEnergySavings;
      // // this.startDate = options.startDate;
      // this.investmentCost = options.investmentCost;
    }
  }

  public toDto(): LoadEnergyEfficiency {
    return new LoadEnergyEfficiency({
      estimatedEnergySavings: this.estimatedEnergySavings,
      // startDate: this.startDate,
      investmentCost: this.investmentCost
    });
  }
}
